import React from "react";
import { Link } from "react-router-dom";
import usePageMeta from "../usePageMeta";

function About() {
  usePageMeta(
    "About – Hisaab Tools",
    "About Hisaab Tools: free, fast, privacy-friendly online calculators for everyday math."
  );

  return (
    <main className="page">
      <div className="calc-card fade-in">
        <h1>About Hisaab Tools</h1>
        <div className="seo-content seo-content-plain">
          <p>
            Hisaab Tools is a collection of free online calculators for the
            math that comes up in everyday life — ages and dates, loans and
            savings, tips and discounts, units and percentages, plus
            Pakistan-specific tools like a Zakat calculator and an FBR income
            tax calculator. Each tool is designed to do one thing well: give
            you an accurate answer in seconds, with a short explanation of how
            it was worked out.
          </p>
          <h2>Our approach</h2>
          <p>
            No accounts, no downloads, no clutter. Every calculation happens
            directly in your browser, which means your numbers are never
            uploaded, logged, or stored. The site is free to use and supported
            by advertising.
          </p>
          <h2>Accuracy</h2>
          <p>
            The formulas used here are standard, widely accepted methods (for
            example, the reducing-balance EMI formula for loans and the
            compound interest formula for savings). Results are intended for
            quick everyday estimates — for financial or medical decisions,
            please consult a qualified professional.
          </p>
          <h2>Contact</h2>
          <p>
            Found a bug or have an idea for a new calculator? We'd love to
            hear it — email{" "}
            <a href="mailto:juniahmad.dev@gmail.com">juniahmad.dev@gmail.com</a>{" "}
            or visit our <Link to="/contact">Contact page</Link>. See our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> for details on how
            the site handles data.
          </p>
        </div>
      </div>
    </main>
  );
}

export default About;
